import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, ChangeDetectorRef, EventEmitter, Output, Input } from '@angular/core';
import { LongHaulService } from 'src/app/shared/services/long-haul.service';
import { LongHaulRequest, LongHaulRequestOption, OptionKey } from 'src/app/shared/models/long-haul.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { LookupService } from 'src/app/front-user/shared/services/lookup.service';
import { VesselType } from 'src/app/front-user/shared/models/vessel-type.modal';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { Country } from 'src/app/front-user/shared/models/country.model';
import { Port } from 'src/app/front-user/shared/models/port.model';
import { SailDirection } from 'src/app/front-user/shared/models/sail-direction.model';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
//import { ReCaptcha2Component } from 'ngx-captcha';
import { User } from 'src/app/front-user/shared/models/user.model';
import { GenericLookup } from 'src/app/front-user/shared/models/generic-lookup.model';
import { AppConfig } from 'src/app/shared/services/app.config';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { CustomValidators } from 'src/app/front-user/shipyard-service/models/custom-validator';
import { MainEngineFuel } from 'src/app/front-user/shared/models/main-fuel-engine';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { DatePipe } from '@angular/common';
//import { Console } from 'console';

@Component({
  selector: 'app-rebate-request',
  templateUrl: './rebate-request.component.html'
})

export class RebateRequestComponent implements OnInit, AfterViewInit {

  private rebateRequest: LongHaulRequest = new LongHaulRequest();
  private rebateRequestObject;
  private submitRebateRequestResponseObject: ResponseObject = new ResponseObject();
  private validRebateRequest: LongHaulRequest = new LongHaulRequest();
  private checkShipIMOValidRebateResponseObject: ResponseObject = new ResponseObject();
  private isETASCGTETAD: boolean = false;
  private showCargoWarning: Boolean = false;
  public vesselTypes: GenericLookup[] = [];
  public countries: GenericLookup[] = [];
  private ValidRequestData: ResponseObject = new ResponseObject();
  public ports: Port[] = [];
  public GSCNT: string;
  private lastPortsOrigin: Port[] = [];
  private firstPortsDestination: Port[] = [];
  public sailDirections: SailDirection[] = [];
  public mainEngineFuels: MainEngineFuel[] = [];
  private showImoWarning: Boolean = false;
  private noOfLoadedLookups: number = 0;
  private noOfLoadingLookups: number = 5;
  //Form Properties
  private mm: Date = new Date();
  public rebateRequestForm: FormGroup;
  private isFormSubmitted: boolean = false;
  private isOptionSubmitted: boolean = false;
  private isOptionsValidatedFromSubmit: boolean = false;
  //Current User
  private currentUserEmail: string = "";
  private currentUserId: string = "";
  //Date Time Properties
  private yearBuiltMaxDate: Date = new Date(Date.now());
  private dateOfSailing: Date = new Date(Date.now());
  //private date22: any = '';
  //private ss: any;
  //private date11: string;
  //Rebate Request Options Properties
  private rebateRequestOptionsArrLength: number = 1;
  //Tabs
  @ViewChild('rebateRequestTabs',{static: false}) rebateRequestTabs: TabsetComponent;
  private isTabOneSubmitted: boolean = false;
  private isTabOneValid: boolean = false;
  private isTabTwoSubmitted: boolean = false;
  private isTabTwoValid: boolean = false;
  private isOptionsArrValid: boolean = false;
  private reltatedFileNo = "";
  @ViewChild('tabOne',{static: false}) tabOneControls: ElementRef;
  @ViewChild('tabTwo',{static: false}) tabTwoControls: ElementRef;
  @ViewChild('tabTwoPrincipal',{static: false}) tabTwoPrincipalControls: ElementRef;
  @ViewChild('options',{static: false}) optionsControls: ElementRef;

  public currentUser: User = new User();
  //Options GridView Properties
  private lastCountryOriginsArr: OptionKey[] = [];
  private firstCountryDestinationsArr: OptionKey[] = [];
  private lastPortOriginsArr: OptionKey[] = [];
  private firstPortDestinationsArr: OptionKey[] = [];
  private isOptionEdited: boolean = false;
  private editedOptionIndex: number = -1;
  public isFormValid: boolean = false;
  private confirmationMessage: string = "";
  public formMode: FormMode = FormMode.New;
  private rebateRequestId: string = "";
  public rebateRequestLoaded: LongHaulRequest = new LongHaulRequest();
  public ParentRequestLoaded: LongHaulRequest = new LongHaulRequest();
  private getRebateRequestResponseObject: ResponseObject = new ResponseObject();
  public showOptionDev: boolean = false;
  public editModeAdmin: boolean = false;
  public ParentCreationDate;
  public ParentCreationDateForSubRequest;
  @Output() rebateRequestLoadedFlag: EventEmitter<boolean> = new EventEmitter();
  public isRequireModificationNotesExist: boolean = false;
  private requireModificationNotes: string = "";
  private requestHasValidIMORebate: boolean = false;
  private noOfDeletedOptions: number = 0;
  private isOptionsHeadersEnabled: boolean = true;
  public isCloneComponent: boolean = false;
  private isRequestDetailsComponent: boolean = false;
  private clonedComponentDirectionId;
  private isDateOfSailingGTETA: boolean = false;
  private noOfOptionsToBeDeletedGlobal: number = 0;
  private requestTimeBeforeSailingDate: number = 0;
  public submitConfirmationMode: ConfirmationMode = ConfirmationMode.Success;

  constructor(private longHaulService: LongHaulService, public datepipe: DatePipe, private lookupService: LookupService, private formBuilder: FormBuilder, private cd: ChangeDetectorRef, private router: ActivatedRoute, private globalServices: GlobalServices, private route: Router, private authenticationService: AuthenticationService) {
    this.currentUser = this.authenticationService.currentUserValue;
    if (!this.currentUser.IsAdmin && this.currentUser.RegisterTypeId == 3) {
      this.route.navigate(['/unAuhtorized']);
    } else {
      let currentUrl: string = window.location.href;
      let lastPartUrl: string = currentUrl.substr(currentUrl.lastIndexOf('/') + 1);
      if (history.state.data && history.state.data.ParentCreationDate) {

        this.ParentCreationDate = history.state.data.ParentCreationDate;
      }
      if (history.state.data && history.state.data.requestId) {
        this.rebateRequestId = history.state.data.requestId;
      } else if (localStorage.getItem('lsRebateRequestId') != undefined) {
        this.rebateRequestId = localStorage.getItem('lsRebateRequestId');
        localStorage.removeItem('lsRebateRequestId');
      } else if (lastPartUrl != "RebateRequest") {
        window.history.back();
      }
      if (lastPartUrl === "CloneRequest")
        this.isCloneComponent = true;
      if (lastPartUrl === "RequestDetails")
        this.isRequestDetailsComponent = true;
    }
  }

  ngOnInit() {

    let ss = new Date(this.ParentCreationDate)
    this.globalServices.isLoaderEnabled = true;
    if (this.isCloneComponent) {
      let xx = ss.getDate();
      this.mm.setDate(xx + 2);
      this.mm.setMonth(ss.getMonth());
      this.mm.setFullYear(ss.getFullYear());
    }
    else {

      // this.getRequestTimeBeforeSailingDate();
    }
    this.loadLookups();
    this.buildForm();
  }
  ngAfterViewInit() {

    this.setDefaults();
  }

  loadLookups(): void {
    this.loadVesselTypes();
    this.loadCountries();
    this.loadSailDirections();
    this.loadMainEngineFuels();
  }
  loadVesselTypes(): void {
    this.lookupService.getVesselTypes().subscribe(
      data => this.vesselTypes = data.Data as VesselType[],
      () => console.log("Something went wrong!!"),
      () => this.loadVesselTypesCompleted()
    );
  }
  onImoChange(value: String): void {

    if (value.length >= 7) {
      this.longHaulService.GetValidRequests(value, this.currentUser.UserName).subscribe(
        data => this.ValidRequestData = data,
        () => console.log("Something went wrong!!"),
        () => this.onImoChangeCheckCompleted()
      );
    }
    else {
      this.showImoWarning = false;
    }

  }
  onImoChangeCheckCompleted() {
    if (this.ValidRequestData.Success) {
      if (this.ValidRequestData.Data[0] != null) {
        this.reltatedFileNo = this.ValidRequestData.Data[0];
        this.showImoWarning = true;
      }
      else {
        this.showImoWarning = false;
      }
    }
    else {
      this.showImoWarning = false;
    }
  }
  loadVesselTypesCompleted(): void {
    let otherVesselType: VesselType = this.vesselTypes.filter(v => v.NameEN == 'Other Vessel')[0];
    this.vesselTypes = this.vesselTypes.filter(v => v.NameEN != 'Other Vessel');
    this.vesselTypes.sort((a, b) => (a.NameEN > b.NameEN) ? 1 : -1);
    this.vesselTypes.push(otherVesselType);
    this.checkLoadedLookups();
  }
  loadCountries(): void {
    this.lookupService.getCountries().subscribe(
      data => this.countries = data.Data as Country[],
      () => console.log("Something went wrong!!"),
      () => this.loadCountriesCompleted()
    );
  }
  loadCountriesCompleted(): void {
    this.countries.sort((a, b) => (a.NameEN > b.NameEN) ? 1 : -1);
    this.loadPorts();
    this.checkLoadedLookups();
  }
  loadPorts(): void {

    this.lookupService.getPorts().subscribe(
      data => this.ports = data.Data as Port[],
      () => console.log("Something went wrong!!"),
      () => this.loadPortsCompleted()
    );
  }
  loadPortsCompleted(): void {

    this.ports.sort((a, b) => (a.NameEN > b.NameEN) ? 1 : -1);
    this.lastPortsOrigin = this.firstPortsDestination = this.ports.filter(item => item.CountryId == this.countries[0].Id);
    this.checkLoadedLookups();
  }
  onLastCountrySelect(countryId: number): void {
    const optionsArray = <FormArray>this.rebateRequestForm.controls['TabTwo'].get('Options');
    optionsArray.controls[this.rebateRequestOptionsArrLength - 1].get('LastPortOriginId').setValue('');
    optionsArray.controls[this.rebateRequestOptionsArrLength - 1].get('OtherLastPortOrigin').setValue('');
    this.lastPortsOrigin = this.ports.filter(item => item.CountryId == countryId);
  }
  onLastPortSelect(portId: number): void {
    const optionsArray = <FormArray>this.rebateRequestForm.controls['TabTwo'].get('Options');
    if (portId == -1) {
      optionsArray.controls[this.rebateRequestOptionsArrLength - 1].patchValue({
        OtherLastPortOrigin: ''
      });
    } else {
      optionsArray.controls[this.rebateRequestOptionsArrLength - 1].patchValue({
        OtherLastPortOrigin: '0'
      });
    }
  }
  onFirstCountrySelect(countryId: number): void {
    const optionsArray = <FormArray>this.rebateRequestForm.controls['TabTwo'].get('Options');
    optionsArray.controls[this.rebateRequestOptionsArrLength - 1].get('FirstPortDestinationId').setValue('');
    optionsArray.controls[this.rebateRequestOptionsArrLength - 1].get('OtherFirstPortDestination').setValue('');
    this.firstPortsDestination = this.ports.filter(item => item.CountryId == countryId);
  }
  onFirstPortSelect(portId: number): void {
    const optionsArray = <FormArray>this.rebateRequestForm.controls['TabTwo'].get('Options');
    if (portId == -1) {
      optionsArray.controls[this.rebateRequestOptionsArrLength - 1].patchValue({
        OtherFirstPortDestination: ''
      });
    } else {
      optionsArray.controls[this.rebateRequestOptionsArrLength - 1].patchValue({
        OtherFirstPortDestination: '0'
      });
    }
  }
  loadSailDirections(): void {
    this.lookupService.getSailDirections().subscribe(
      data => this.sailDirections = data.Data as SailDirection[],
      () => console.log("Something went wrong!!"),
      () => this.loadSailDirectionsCompleted()
    );
  }
  loadSailDirectionsCompleted(): void {
    this.sailDirections.sort((a, b) => (a.Direction > b.Direction) ? 1 : -1);
    this.checkLoadedLookups();
  }
  loadMainEngineFuels(): void {
    this.lookupService.getMainEngineFuels().subscribe(
      data => this.mainEngineFuels = data.Data as MainEngineFuel[],
      () => console.log("Something went wrong!!"),
      () => this.loadMainEngineFuelsCompleted()
    );
  }
  loadMainEngineFuelsCompleted(): void {
    this.mainEngineFuels.sort((a, b) => (a.Fuel > b.Fuel) ? 1 : -1);
    this.checkLoadedLookups();
  }
  checkLoadedLookups(): void {
    this.noOfLoadedLookups++;
    if (this.noOfLoadedLookups == this.noOfLoadingLookups) {
      this.setFormMode();
    }
  }
  buildForm(): void {
    this.rebateRequestForm = this.formBuilder.group({
      TabOne: this.formBuilder.group({
        Email: [''],
        OperatorName: ['', [Validators.pattern("[^=]+"), Validators.maxLength(200)]],
        OperatorEmail: ['', [Validators.pattern('^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9_\\-\\.]+)\\.([a-zA-Z]{2,9})$'), Validators.maxLength(50)]],
        VesselName: ['', [Validators.required, Validators.pattern("[^=]+"), Validators.maxLength(200)]],
        VesselTypeId: ['', [Validators.required]],
        ExNames: [''],
        YearBuilt: ['', [Validators.required]],
        CallSign: ['', [Validators.required, Validators.pattern("^[a-zA-Z0-9]*$"), Validators.maxLength(200)]],
        IMONo: ['', [Validators.required, Validators.pattern("^[0-9]{7,9}$")]],
        DWT: ['', [Validators.required, Validators.pattern("^[0-9]{1,6}$"), Validators.maxLength(50)]],
        SCNT: ['', [Validators.required, Validators.pattern("^[1-9][0-9]{0,5}([.][0-9]{1,2}|)$"), Validators.maxLength(50)]],
        LastTransitDate: [''],
        LPGLNGCapacity: ['', [Validators.pattern("^[0-9]{1,6}$"), Validators.maxLength(50)]],
        ReeferCapacity: ['', [Validators.pattern("^[0-9]{1,6}$"), Validators.maxLength(50)]],
        MAXDraught: ['', [Validators.pattern("^[1-9][0-9]{0,1}([.][0-9]{1,2}|)$"), Validators.maxLength(200)]],
        TRNDraught: ['', [Validators.required, Validators.pattern("^[1-9][0-9]{0,1}([.][0-9]{1,2}|)$"), Validators.maxLength(200)]],
        Beam: ['', [Validators.required, Validators.pattern("^[1-9][0-9]{0,2}([.][0-9]{1,2}|)$"), Validators.maxLength(200)]],
        DesignSpeed: ['', [Validators.pattern("^[1-9][0-9]{0,1}([.][0-9]{1,2}|)$"), Validators.maxLength(200)]],
        IsScrubberFitted: ['', [Validators.required]],
        MainEngineFuelId: [''],
        OtherMainEngineFuel: ['', [Validators.required]],
        FuelIFO: ['', [Validators.pattern("^[0-9]{0,2}([.][1-9]{1}|)$"), Validators.maxLength(200)]],
        FuelDO: ['', [Validators.pattern("^[0-9]{0,2}([.][1-9]{1}|)$"), Validators.maxLength(200)]],
        IsShipLoaded: ['', [Validators.required]],
        CargoKind: ['', [Validators.required, Validators.pattern("[^=]+"), Validators.maxLength(200)]],
        CargoQuantity: ['', [Validators.required, Validators.pattern("^[0-9]{1,6}$"), Validators.maxLength(200)]],
        RebateNote: [''],
        AdminDirectionId: ['', [Validators.required]],
        AdminDateOfSailing: ['', [Validators.required, CustomValidators.dateValidator()]],
        AdminETA: ['', [Validators.required, CustomValidators.SeventyThreeDaysRole(), CustomValidators.dateValidator()]],
      }),
      TabTwo: this.formBuilder.group({
        Options: this.formBuilder.array([this.buildLongHaulOptionsForm()]),
        DirectionId: ['', [Validators.required]],
        Name: ['', [Validators.required, Validators.pattern("[^=]+"), Validators.maxLength(200)]],
        EMail: ['', [Validators.required, Validators.pattern('^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9_\\-\\.]+)\\.([a-zA-Z]{2,9})$'), Validators.maxLength(50)]],
        Fax: ['', [Validators.pattern("^(\\+?\\d{1,}(\\s?|\\-?)\\d*(\\s?|\\-?)\\(?\\d{2,}\\)?(\\s?|\\-?)\\d{3,}\\s?\\d{3,})$")]],
        TermsConditions: [false, [Validators.requiredTrue]]
      })
    });
  }
  buildLongHaulOptionsForm(): FormGroup {
    return this.formBuilder.group({
      ActualSpeed: ['', [Validators.required, Validators.pattern("^[1-9][0-9]{0,1}([.][0-9]{1,2}|)$"), Validators.maxLength(50)]],
      LastCountryOriginId: ['', [Validators.required]],
      LastPortOriginId: ['', [Validators.required]],
      OtherLastPortOrigin: ['', [Validators.required]],
      FirstCountryDestinationId: ['', [Validators.required]],
      FirstPortDestinationId: ['', [Validators.required]],
      OtherFirstPortDestination: ['', [Validators.required]],
      DistanceMilesSuez: ['', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(200)]],
      DistanceMilesPanama: ['', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(200)]],
      DiffInDistance: ['', [Validators.required, Validators.maxLength(200)]],
      WhetherSuez: [''],
      WhetherPanama: [''],
      DurationSuez: ['', [Validators.required, Validators.pattern("^[1-9][0-9]*([.][1-9]{1}|)$"), Validators.maxLength(50)]],
      DurationPanama: ['', [Validators.required, Validators.pattern("^[1-9][0-9]*([.][1-9]{1}|)$"), Validators.maxLength(50)]],
      AntiPiracyCostSuez: ['', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(200)]],
      AntiPiracyCostPanama: ['', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(200)]],
      IFOTon: ['', [Validators.required, Validators.pattern("^[1-9][0-9]{0,2}([.][0-9]{1,2}|)$"), Validators.maxLength(50)]],
      IFOTonPrice: ['', [Validators.required, Validators.pattern("^[1-9][0-9]{0,3}([.][0-9]{1,2}|)$"), Validators.maxLength(200)]],
      DOTon: ['', [Validators.pattern("^[0-9]{0,3}([.][0-9]{1,2}|)$"), Validators.maxLength(50)]],
      DOTonPrice: ['', [Validators.required, Validators.pattern("^[1-9][0-9]{0,3}([.][0-9]{1,2}|)$"), Validators.maxLength(200)]],
      DailyTimeCharter: ['', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(200)]],
      SCTolls: ['', [Validators.required, Validators.pattern("^[1-9][0-9]*([.][0-9]{1,2}|)$"), Validators.maxLength(200)]],
      SCOtherCharges: ['', [Validators.pattern("^[1-9][0-9]*([.][0-9]{1,2}|)$"), Validators.maxLength(200)]],
      PanamaTolls: ['', [Validators.pattern("^[0-9]*([.][0-9]{1,2}|)$"), Validators.maxLength(200)]],
      PanamaOtherCharges: ['', [Validators.pattern("^[0-9]*([.][0-9]{1,2}|)$"), Validators.maxLength(200)]],
      CargoSuezTon: ['', [Validators.pattern("^[0-9]*$"), Validators.maxLength(50)]],
      CargoPanamaTon: ['', [Validators.pattern("^[0-9]*$"), Validators.maxLength(50)]],
      FreightPerTon: ['', [Validators.pattern("^[0-9]*$"), Validators.maxLength(200)]],
      CargoLostValue: ['', [Validators.pattern("^[0-9]*$"), Validators.maxLength(200)]],
      TotalCostSuez: ['', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(200)]],
      TotalCostPanama: ['', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(200)]],
      DiffInCost: ['', [Validators.required, Validators.pattern("^[1-9][0-9]*([.][0-9]{2}|)$"), Validators.maxLength(200)]],
      SuggestedRebate: ['', [Validators.required, Validators.pattern("^[0-9]*([.][0-9]{1}|)$")]],
      DateOfSailing: ['', [Validators.required, CustomValidators.dateValidator()]],
      ETA: ['', [Validators.required, CustomValidators.SeventyThreeDaysRole(), CustomValidators.dateValidator()]],
      Id: [''],
      IsOptionDeleted: [false]
    });
  }
  onOpenYearBuiltCalendar(container) {

    container.yearSelectHandler = (event: any): void => {
      container._store.dispatch(container._actions.select(event.date));
    };
    container.setViewMode('year');
  }
  selectTab(targetTabNumber: number): void {
    if (targetTabNumber == 2) {
      this.isTabOneSubmitted = true;
      const invalidControls = this.tabOneControls.nativeElement.querySelectorAll('.ng-invalid');
      if (this.rebateRequestForm.controls['TabOne'].valid || invalidControls.length == 0) {
        this.isTabOneValid = true;
        this.rebateRequestTabs.tabs[targetTabNumber - 1].disabled = false;
        this.rebateRequestTabs.tabs[targetTabNumber - 1].active = true;
        this.cd.detectChanges();
        const el = document.getElementsByClassName('sectionTitle');
        el[0].scrollIntoView({ behavior: 'smooth' });
      } else {
        invalidControls[0].focus();
        //}
      }
    } else {
      this.rebateRequestTabs.tabs[targetTabNumber - 1].active = true;
      this.cd.detectChanges();
    }
  }

  addNewVoyage(): void {

    this.isOptionSubmitted = true;
    const invalidControls = this.optionsControls.nativeElement.querySelectorAll('.ng-invalid');
    if (invalidControls.length == 0) {
      if (this.rebateRequestForm.controls['TabTwo'].value['Options'][this.rebateRequestOptionsArrLength - 1].DateOfSailing > this.rebateRequestForm.controls['TabTwo'].value['Options'][this.rebateRequestOptionsArrLength - 1].ETA) {
        const el = document.getElementById('dpDateOfSailing');
        el.focus();
        this.isDateOfSailingGTETA = true;
      } else {
        this.isDateOfSailingGTETA = false;
        this.isOptionsArrValid = true;
        (<FormArray>this.rebateRequestForm.controls['TabTwo'].get('Options')).push(this.buildLongHaulOptionsForm());
        this.mapCountriesPortsKeys(this.rebateRequestOptionsArrLength - 1, this.rebateRequestForm.controls['TabTwo'].value['Options'][this.rebateRequestOptionsArrLength - 1].LastCountryOriginId, this.rebateRequestForm.controls['TabTwo'].value['Options'][this.rebateRequestOptionsArrLength - 1].FirstCountryDestinationId, this.rebateRequestForm.controls['TabTwo'].value['Options'][this.rebateRequestOptionsArrLength - 1].LastPortOriginId, this.rebateRequestForm.controls['TabTwo'].value['Options'][this.rebateRequestOptionsArrLength - 1].FirstPortDestinationId, this.rebateRequestForm.controls['TabTwo'].value['Options'][this.rebateRequestOptionsArrLength - 1].OtherLastPortOrigin, this.rebateRequestForm.controls['TabTwo'].value['Options'][this.rebateRequestOptionsArrLength - 1].OtherFirstPortDestination);

        this.rebateRequestOptionsArrLength++;
        this.isOptionSubmitted = false;
        const el = document.getElementsByClassName('sectionTitle');
        el[0].scrollIntoView({ behavior: 'smooth' });
      }
    } else if (invalidControls.length > 0) {
      invalidControls[0].focus();
      if (this.rebateRequestForm.controls['TabTwo'].value['Options'][this.rebateRequestOptionsArrLength - 1].DateOfSailing > this.rebateRequestForm.controls['TabTwo'].value['Options'][this.rebateRequestOptionsArrLength - 1].ETA) {
        const el = document.getElementById('dpDateOfSailing');
        el.scrollIntoView({ behavior: 'smooth' });
        this.isDateOfSailingGTETA = true;
      }
    }
    this.isOptionsHeadersEnabled = true;
  }
  dateOfSailingChange(): void {
    if (this.rebateRequestForm.controls['TabTwo'].value['Options'][this.rebateRequestOptionsArrLength - 1].DateOfSailing != "" && this.rebateRequestForm.controls['TabTwo'].value['Options'][this.rebateRequestOptionsArrLength - 1].DateOfSailing != null && this.rebateRequestForm.controls['TabTwo'].value['Options'][this.rebateRequestOptionsArrLength - 1].ETA != "" && this.rebateRequestForm.controls['TabTwo'].value['Options'][this.rebateRequestOptionsArrLength - 1].ETA != null) {
      (this.rebateRequestForm.controls['TabTwo'].value['Options'][this.rebateRequestOptionsArrLength - 1].DateOfSailing as Date).setHours(0, 0, 0, 0);
      (this.rebateRequestForm.controls['TabTwo'].value['Options'][this.rebateRequestOptionsArrLength - 1].ETA as Date).setHours(0, 0, 0, 0);
      if (this.rebateRequestForm.controls['TabTwo'].value['Options'][this.rebateRequestOptionsArrLength - 1].DateOfSailing <= this.rebateRequestForm.controls['TabTwo'].value['Options'][this.rebateRequestOptionsArrLength - 1].ETA)
        this.isDateOfSailingGTETA = false;
      else if (this.rebateRequestForm.controls['TabTwo'].value['Options'][this.rebateRequestOptionsArrLength - 1].DateOfSailing > this.rebateRequestForm.controls['TabTwo'].value['Options'][this.rebateRequestOptionsArrLength - 1].ETA)
        this.isDateOfSailingGTETA = true;
    } else {
      this.isDateOfSailingGTETA = false;
    }
  }
  distanceChange(): void {
    if (this.rebateRequestForm.controls['TabTwo'].value['Options'][this.rebateRequestOptionsArrLength - 1].DistanceMilesSuez != "" && !isNaN(this.rebateRequestForm.controls['TabTwo'].value['Options'][this.rebateRequestOptionsArrLength - 1].DistanceMilesSuez) && this.rebateRequestForm.controls['TabTwo'].value['Options'][this.rebateRequestOptionsArrLength - 1].DistanceMilesPanama != "" && !isNaN(this.rebateRequestForm.controls['TabTwo'].value['Options'][this.rebateRequestOptionsArrLength - 1].DistanceMilesPanama)) {
      const optionsArray = <FormArray>this.rebateRequestForm.controls['TabTwo'].get('Options');
      optionsArray.controls[this.rebateRequestOptionsArrLength - 1].patchValue({
        DiffInDistance: this.rebateRequestForm.controls['TabTwo'].value['Options'][this.rebateRequestOptionsArrLength - 1].DistanceMilesPanama - this.rebateRequestForm.controls['TabTwo'].value['Options'][this.rebateRequestOptionsArrLength - 1].DistanceMilesSuez
      });
    }
  }
  editOption(optionIndex): void {
    this.isOptionEdited = true;
    this.editedOptionIndex = optionIndex;
    this.emptyCurrentOptionControls();
    const optionsArray = <FormArray>this.rebateRequestForm.controls['TabTwo'].get('Options');
    this.copyOptionToOption(optionsArray, optionIndex, optionsArray.length - 1);
    if (this.formMode == FormMode.Edit) {
      this.showOptionDev = true;
      this.cd.detectChanges();
    }
  }
  saveEditedVoyage(): void {
    this.isOptionSubmitted = true;
    const invalidControls = this.optionsControls.nativeElement.querySelectorAll('.ng-invalid');
    if (invalidControls.length == 0) {
      const optionsArray = <FormArray>this.rebateRequestForm.controls['TabTwo'].get('Options');
      this.copyOptionToOption(optionsArray, optionsArray.length - 1, this.editedOptionIndex);
      this.editMapCountriesKeys(this.editedOptionIndex, this.rebateRequestForm.controls['TabTwo'].value['Options'][this.editedOptionIndex].LastCountryOriginId, this.rebateRequestForm.controls['TabTwo'].value['Options'][this.editedOptionIndex].FirstCountryDestinationId, this.rebateRequestForm.controls['TabTwo'].value['Options'][this.editedOptionIndex].LastPortOriginId, this.rebateRequestForm.controls['TabTwo'].value['Options'][this.editedOptionIndex].FirstPortDestinationId, this.rebateRequestForm.controls['TabTwo'].value['Options'][this.editedOptionIndex].OtherLastPortOrigin, this.rebateRequestForm.controls['TabTwo'].value['Options'][this.editedOptionIndex].OtherFirstPortDestination);
      this.editedOptionIndex = -1;
      this.isOptionEdited = false;
      this.emptyCurrentOptionControls();
      this.isOptionSubmitted = false;
      const el = document.getElementsByClassName('sectionTitle');
      el[0].scrollIntoView({ behavior: 'smooth' });
    } else if (invalidControls.length > 0) {
      invalidControls[0].focus();
    }
  }
  emptyCurrentOptionControls(): void {
    const optionsArray = <FormArray>this.rebateRequestForm.controls['TabTwo'].get('Options');
    optionsArray.controls[optionsArray.length - 1].get('ActualSpeed').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('LastCountryOriginId').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('LastPortOriginId').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('OtherLastPortOrigin').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('FirstCountryDestinationId').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('FirstPortDestinationId').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('OtherFirstPortDestination').setValue('');

    optionsArray.controls[optionsArray.length - 1].get('DistanceMilesSuez').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('DistanceMilesPanama').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('DiffInDistance').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('WhetherSuez').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('WhetherPanama').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('DurationSuez').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('DurationPanama').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('AntiPiracyCostSuez').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('AntiPiracyCostPanama').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('IFOTon').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('IFOTonPrice').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('DOTon').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('DOTonPrice').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('DailyTimeCharter').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('SCTolls').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('SCOtherCharges').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('PanamaTolls').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('PanamaOtherCharges').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('CargoSuezTon').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('CargoPanamaTon').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('FreightPerTon').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('CargoLostValue').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('TotalCostSuez').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('TotalCostPanama').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('DiffInCost').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('SuggestedRebate').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('DateOfSailing').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('ETA').setValue('');
  }
  copyOptionToOption(optionsArray, fromIndex, toIndex): void {
    this.lastPortsOrigin = this.ports.filter((item) => item.CountryId == optionsArray.controls[fromIndex].value.LastCountryOriginId);
    this.firstPortsDestination = this.ports.filter((item) => item.CountryId == optionsArray.controls[fromIndex].value.FirstCountryDestinationId);
    optionsArray.controls[toIndex].get('ActualSpeed').setValue(optionsArray.controls[fromIndex].value.ActualSpeed);
    optionsArray.controls[toIndex].get('LastCountryOriginId').setValue(optionsArray.controls[fromIndex].value.LastCountryOriginId);
    optionsArray.controls[toIndex].get('LastPortOriginId').setValue(optionsArray.controls[fromIndex].value.LastPortOriginId);
    optionsArray.controls[toIndex].get('OtherLastPortOrigin').setValue(optionsArray.controls[fromIndex].value.OtherLastPortOrigin);
    optionsArray.controls[toIndex].get('FirstCountryDestinationId').setValue(optionsArray.controls[fromIndex].value.FirstCountryDestinationId);
    optionsArray.controls[toIndex].get('FirstPortDestinationId').setValue(optionsArray.controls[fromIndex].value.FirstPortDestinationId);
    optionsArray.controls[toIndex].get('OtherFirstPortDestination').setValue(optionsArray.controls[fromIndex].value.OtherFirstPortDestination);
    optionsArray.controls[toIndex].get('DistanceMilesSuez').setValue(optionsArray.controls[fromIndex].value.DistanceMilesSuez);
    optionsArray.controls[toIndex].get('DistanceMilesPanama').setValue(optionsArray.controls[fromIndex].value.DistanceMilesPanama);
    optionsArray.controls[toIndex].get('DiffInDistance').setValue(optionsArray.controls[fromIndex].value.DiffInDistance);
    optionsArray.controls[toIndex].get('WhetherSuez').setValue(optionsArray.controls[fromIndex].value.WhetherSuez);
    optionsArray.controls[toIndex].get('WhetherPanama').setValue(optionsArray.controls[fromIndex].value.WhetherPanama);
    optionsArray.controls[toIndex].get('DurationSuez').setValue(optionsArray.controls[fromIndex].value.DurationSuez);
    optionsArray.controls[toIndex].get('DurationPanama').setValue(optionsArray.controls[fromIndex].value.DurationPanama);
    optionsArray.controls[toIndex].get('AntiPiracyCostSuez').setValue(optionsArray.controls[fromIndex].value.AntiPiracyCostSuez);
    optionsArray.controls[toIndex].get('AntiPiracyCostPanama').setValue(optionsArray.controls[fromIndex].value.AntiPiracyCostPanama);
    optionsArray.controls[toIndex].get('IFOTon').setValue(optionsArray.controls[fromIndex].value.IFOTon);
    optionsArray.controls[toIndex].get('IFOTonPrice').setValue(optionsArray.controls[fromIndex].value.IFOTonPrice);
    optionsArray.controls[toIndex].get('DOTon').setValue(optionsArray.controls[fromIndex].value.DOTon);
    optionsArray.controls[toIndex].get('DOTonPrice').setValue(optionsArray.controls[fromIndex].value.DOTonPrice);
    optionsArray.controls[toIndex].get('DailyTimeCharter').setValue(optionsArray.controls[fromIndex].value.DailyTimeCharter);
    optionsArray.controls[toIndex].get('SCTolls').setValue(optionsArray.controls[fromIndex].value.SCTolls);
    optionsArray.controls[toIndex].get('SCOtherCharges').setValue(optionsArray.controls[fromIndex].value.SCOtherCharges);
    optionsArray.controls[toIndex].get('PanamaTolls').setValue(optionsArray.controls[fromIndex].value.PanamaTolls);
    optionsArray.controls[toIndex].get('PanamaOtherCharges').setValue(optionsArray.controls[fromIndex].value.PanamaOtherCharges);
    optionsArray.controls[toIndex].get('CargoSuezTon').setValue(optionsArray.controls[fromIndex].value.CargoSuezTon);
    optionsArray.controls[toIndex].get('CargoPanamaTon').setValue(optionsArray.controls[fromIndex].value.CargoPanamaTon);
    optionsArray.controls[toIndex].get('FreightPerTon').setValue(optionsArray.controls[fromIndex].value.FreightPerTon);
    optionsArray.controls[toIndex].get('CargoLostValue').setValue(optionsArray.controls[fromIndex].value.CargoLostValue);
    optionsArray.controls[toIndex].get('TotalCostSuez').setValue(optionsArray.controls[fromIndex].value.TotalCostSuez);
    optionsArray.controls[toIndex].get('TotalCostPanama').setValue(optionsArray.controls[fromIndex].value.TotalCostPanama);
    optionsArray.controls[toIndex].get('DiffInCost').setValue(optionsArray.controls[fromIndex].value.DiffInCost);
    optionsArray.controls[toIndex].get('SuggestedRebate').setValue(optionsArray.controls[fromIndex].value.SuggestedRebate);
    optionsArray.controls[toIndex].get('DateOfSailing').setValue(optionsArray.controls[fromIndex].value.DateOfSailing);
    optionsArray.controls[toIndex].get('ETA').setValue(optionsArray.controls[fromIndex].value.ETA);
  }
  cancelEditVoyage(): void {
    this.emptyCurrentOptionControls();
    this.editedOptionIndex = -1;
    this.isOptionEdited = false;
    const el = document.getElementsByClassName('sectionTitle');
    el[0].scrollIntoView({ behavior: 'smooth' });
  }
  deleteOption(optionIndex): void {
    const optionsArray = <FormArray>this.rebateRequestForm.controls['TabTwo'].get('Options');
    optionsArray.controls[optionIndex].patchValue({
      IsOptionDeleted: true
    });
    let noOfOptionsToBeDeleted: number = 0
    for (let i: number = 0; i < (<FormArray>this.rebateRequestForm.controls['TabTwo'].get('Options').value).length; i++) {
      let option = (<FormArray>this.rebateRequestForm.controls['TabTwo'].get('Options')).controls[i];
      if (option.value["IsOptionDeleted"])
        noOfOptionsToBeDeleted++;
    }
    if ((this.rebateRequestOptionsArrLength - noOfOptionsToBeDeleted) == 1)
      this.isOptionsHeadersEnabled = false;
    this.noOfOptionsToBeDeletedGlobal = noOfOptionsToBeDeleted;
  }
  detailsOption(optionIndex): void {
    this.showOptionDev = true;
    this.emptyCurrentOptionControls();
    const optionsArray = <FormArray>this.rebateRequestForm.controls['TabTwo'].get('Options');
    this.copyOptionToOption(optionsArray, optionIndex, optionsArray.length - 1);
    if (this.formMode == FormMode.Edit || this.formMode == FormMode.Details)
      this.cd.detectChanges();

  }

  submit(): void {
    if (this.formMode == FormMode.Edit)
      this.isTabOneSubmitted = true;
    this.isFormSubmitted = true;
    this.isTabTwoSubmitted = true;

    if (this.rebateRequestForm.controls['TabTwo'].get('Options').value.length != 1 && this.formMode == FormMode.Edit) {
      this.isOptionsArrValid = true;
    }
    //Count Number of Deleted Options
    for (let i: number = 0; i < (<FormArray>this.rebateRequestForm.controls['TabTwo'].get('Options').value).length; i++) {
      let option = (<FormArray>this.rebateRequestForm.controls['TabTwo'].get('Options')).controls[i];
      if (option.value["IsOptionDeleted"])
        this.noOfDeletedOptions++;
    }
    //Tab One Validity
    const tabOneInValidControls = this.tabOneControls.nativeElement.querySelectorAll('.ng-invalid');
    const tabTwoInValidControls = this.tabTwoControls.nativeElement.querySelectorAll('.ng-invalid');
    const tabTwoPrincipalInValidControls = this.tabTwoPrincipalControls.nativeElement.querySelectorAll('.ng-invalid');
    if (!this.rebateRequestForm.controls['TabOne'].valid && tabOneInValidControls.length > 0) {
      this.rebateRequestTabs.tabs[0].active = true;
      this.cd.detectChanges();
      if (tabOneInValidControls.length > 0)
        tabOneInValidControls[0].focus();
      //Options Validation
    } else if ((this.rebateRequestForm.controls['TabTwo'].get('Options').value.length - this.noOfDeletedOptions) == 1) {
      //Default Array Contain at Least One Object
      this.rebateRequestTabs.tabs[1].active = true;
      this.cd.detectChanges();
      this.isOptionsArrValid = false;
      const invalidControls = this.optionsControls.nativeElement.querySelectorAll('.ng-invalid');
      if (invalidControls.length > 0) {
        invalidControls[0].focus();
      } else {
        const el = document.getElementsByClassName('sectionTitle');
        el[0].scrollIntoView({ behavior: 'smooth' });
      }
      //Identifier that [Submit Button] not [Add New Voyage Button]
      if (this.isOptionsValidatedFromSubmit)
        this.isOptionSubmitted = true;
      this.isOptionsValidatedFromSubmit = true;
      //Tab Two Validity
    } else if (!this.rebateRequestForm.controls['TabTwo'].valid && tabTwoInValidControls.length > 0) {
      this.isTabTwoValid = false;
      this.rebateRequestTabs.tabs[1].active = true;
      this.cd.detectChanges();
      if (tabTwoInValidControls.length > 0) {
        tabTwoInValidControls[0].focus();

      }

    } else if (!this.rebateRequestForm.controls['TabTwo'].valid && tabTwoPrincipalInValidControls.length > 0) {
      this.isTabTwoValid = false;
      this.rebateRequestTabs.tabs[1].active = true;
      this.cd.detectChanges();
      if (tabTwoInValidControls.length > 0)
        tabTwoInValidControls[0].focus();
      //Form Valid
    } else {
      this.rebateRequestObject = { ...this.rebateRequestForm.controls['TabOne'].value, ...this.rebateRequestForm.controls['TabTwo'].value };
      this.rebateRequestObject.Options.pop();
      let directionId = this.rebateRequestObject.DirectionId;
      delete this.rebateRequestObject.DirectionId;
      for (let i: number = 0; i < this.rebateRequestObject.Options.length; i++) {
        if (directionId != undefined)
          this.rebateRequestObject.Options[i]["DirectionId"] = directionId;
        else
          this.rebateRequestObject.Options[i]["DirectionId"] = this.clonedComponentDirectionId;
      }
      //Enable Loader
      this.globalServices.isLoaderEnabled = true;
      //Submit Request
      this.rebateRequestObject.LongHaulRequestOptions = this.rebateRequestObject.Options;
      for (let i: number = 0; i < this.rebateRequestObject.LongHaulRequestOptions.length; i++) {
        if (this.rebateRequestObject.LongHaulRequestOptions[i].LastPortOriginId == -1)
          this.rebateRequestObject.LongHaulRequestOptions[i].LastPortOriginId = null;
        if (this.rebateRequestObject.LongHaulRequestOptions[i].FirstPortDestinationId == -1)
          this.rebateRequestObject.LongHaulRequestOptions[i].FirstPortDestinationId = null;
      }
      if (this.rebateRequestObject.MainEngineFuelId == -1)
        this.rebateRequestObject.MainEngineFuelId = null;
      if (this.isCloneComponent) {
        this.rebateRequestObject.RequestorId = this.currentUser.UserId;
        this.rebateRequestObject.RequestorEmail = this.currentUser.UserName != "" ? this.currentUser.UserName : this.currentUser.Email;
        this.rebateRequestObject.Id = this.rebateRequestLoaded.Id;
        this.rebateRequestObject.ServiceId = 2;
        this.rebateRequestObject.StatusId = 1;
        this.rebateRequestObject.IsSubmitClone = true;
        this.submitRebateRequest();
      } else {
        if (this.formMode == FormMode.New) {
          this.rebateRequestObject.RequestorId = this.currentUserId;
          this.rebateRequestObject.RequestorEmail = this.currentUserEmail;
          this.rebateRequestObject.ServiceId = 2;
          this.rebateRequestObject.StatusId = 1;
          this.rebateRequestObject.IsSubmitClone = false;
          this.submitRebateRequest();
        } else if (this.formMode == FormMode.Edit) {
          this.rebateRequestObject.RequestorEmail = this.currentUserEmail;
          this.rebateRequestObject.Id = this.rebateRequestLoaded.Id;
          this.rebateRequestObject.InternalStatusId = this.rebateRequestLoaded.InternalStatusId;
          this.rebateRequestObject.ExternalStatusId = this.rebateRequestLoaded.ExternalStatusId;
          this.rebateRequestObject.CreatedBy = this.rebateRequestLoaded.CreatedBy;
          this.rebateRequestObject.CreationDate = this.rebateRequestLoaded.CreationDate;
          this.rebateRequestObject.ModifiedBy = this.rebateRequestLoaded.ModifiedBy;
          this.rebateRequestObject.ModifiedDate = this.rebateRequestLoaded.ModifiedDate;
          this.rebateRequestObject.IsDeleted = this.rebateRequestLoaded.IsDeleted;
          this.rebateRequestObject.IsEditable = this.rebateRequestLoaded.IsEditable;
          this.rebateRequestObject.RebateFileNumber = this.rebateRequestLoaded.RebateFileNumber;
          this.rebateRequestObject.RebateStatusId = this.rebateRequestLoaded.RebateStatusId;
          this.rebateRequestObject.IsShipPassed = this.rebateRequestLoaded.IsShipPassed;
          this.rebateRequestObject.CancelationReason = this.rebateRequestLoaded.CancelationReason;
          this.rebateRequestObject.CancelationMessage = this.rebateRequestLoaded.CancelationMessage;
          this.isRequireModificationNotesExist = false;
          this.submitEditedRebateRequest();
        }
      }
    }
    this.noOfDeletedOptions = 0;
  }

  onCargoChange(value: String): void {

    let dw = this.rebateRequestForm.controls['TabOne'].get('DWT').value;

    if (Number(value) > Number(dw)) {
      this.showCargoWarning = true;
    }
    else {
      this.showCargoWarning = false;
    }
  }

  submitRebateRequest(): void {
    this.setDateTimeDefault();
    this.longHaulService.submitRebateRequest(this.rebateRequestObject).subscribe(
      data => this.submitRebateRequestResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.submitRebateRequestCompleted()
    );
  }
  submitRebateRequestCompleted(): void {
    if (this.submitRebateRequestResponseObject.Success) {
      //Enable Confirmation
      this.confirmationMessage = "Your Request has been successfully submitted and is being reviewed by Suez Canal Authority Team";
    } else {
      //Enable Error
      this.submitConfirmationMode = ConfirmationMode.Error;
    }
    this.isFormValid = true;
    //Disable Loader
    this.globalServices.isLoaderEnabled = false;
  }
  submitEditedRebateRequest(): void {
    this.setDateTimeDefault();
    this.longHaulService.submitEditedRebateRequest(this.rebateRequestObject).subscribe(
      data => this.submitRebateRequestResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.submitEditedRebateRequestCompleted()
    );
  }
  submitEditedRebateRequestCompleted(): void {
    if (this.submitRebateRequestResponseObject.Success) {
      //Enable Confirmation
      this.confirmationMessage = "Your Request has been successfully edited and is being reviewed by Suez Canal Authority Team";
    } else {
      //Enable Error
      this.submitConfirmationMode = ConfirmationMode.Error;
    }
    this.isFormValid = true;
    //Disable Loader
    this.globalServices.isLoaderEnabled = false;
  }
  //Requester Functions
  getCurrentLoggedUser(): void {
    //Staging Mode
    this.currentUserEmail = this.currentUser.UserName != "" ? this.currentUser.UserName : this.currentUser.Email;
    this.currentUserId = this.currentUser.UserId;
    //Dev Mode
    //this.currentUserEmail = "ghada.comp@gmail.com";
    //this.currentUserId = "B992323A-DA3A-472E-8184-7075DFB262B8";
    //this.currentUserEmail = "username294@gmail.com";
    //this.currentUserId = "0B244884-015D-450F-B51D-FA7E9F1A559B";
    const el = document.getElementsByClassName('sectionTitle');
    if (el[0] != undefined)
      el[0].scrollIntoView({ behavior: 'smooth' });
    this.globalServices.isLoaderEnabled = false;
  }

  setDefaults(): void {

    if (!this.isCloneComponent) {
      this.getRequestTimeBeforeSailingDate();
    }
    this.rebateRequestTabs.tabs[1].disabled = false; //here
    this.cd.detectChanges();
  }
  /*getRequestTimeBeforeSailingDate(): void {
    this.longHaulService.getRequestTimeBeforeSailingDate().subscribe(
      data => this.requestTimeBeforeSailingDate = data.Data,
      () => console.log("Something went wrong!!"),
      () => this.getRequestTimeBeforeSailingDateCompleted()
    );
  }*/
  getRequestTimeBeforeSailingDate(): void {
    this.getRequestTimeBeforeSailingDateCompleted()

  }
  getRequestTimeBeforeSailingDateCompleted(): void {
    //let requestTimeBeforeSailingDateDays = Math.floor(this.requestTimeBeforeSailingDate / 24);
    let requestTimeBeforeSailingDateDays = 2;

    this.dateOfSailing.setDate(this.dateOfSailing.getDate() + requestTimeBeforeSailingDateDays);



  }
  setFormMode(): void {
    if (this.rebateRequestId != '') {
      //Enable Loader
      this.globalServices.isLoaderEnabled = true;
      this.getRebateRequest();
    } else {
      //New Mode
      this.showOptionDev = true;
      this.getCurrentLoggedUser();
    }
  }
  LaodParentData(parentID): void {
    this.longHaulService.getRebateRequest(parentID).subscribe(
      data => this.getRebateRequestResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.getParentRebateRequestCompleted()
    );
  }
  getParentRebateRequestCompleted(): void {
    if (this.getRebateRequestResponseObject.Success) {

      this.ParentRequestLoaded = this.getRebateRequestResponseObject.Data as LongHaulRequest;
      this.ParentCreationDateForSubRequest = this.ParentRequestLoaded.BaseRequest.CreationDate;
    }
  }
  getRebateRequest(): void {
    this.longHaulService.getRebateRequest(this.rebateRequestId).subscribe(
      data => this.getRebateRequestResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.getRebateRequestCompleted()
    );
  }
  getRebateRequestCompleted(): void {

    if (this.getRebateRequestResponseObject.Success) {
      this.rebateRequestLoaded = this.getRebateRequestResponseObject.Data as LongHaulRequest;
      this.GSCNT = this.rebateRequestLoaded.SCNT;
      //this.ss = this.datepipe.transform(this.rebateRequestLoaded.LongHaulRequestOptions[0].DateOfSailing, 'dd-MM-yyyy');
      if (this.rebateRequestLoaded.ParentRequestNumber) {
        this.LaodParentData(this.rebateRequestLoaded.BaseRequest.ParentRequestId);
      }
      this.rebateRequestLoadedFlag.emit(true);

      if (this.rebateRequestTabs.tabs[1] != undefined) {
        this.rebateRequestTabs.tabs[1].disabled = false;
        this.cd.detectChanges();
      }
      this.fillRebateRequestObject();
      if (this.rebateRequestLoaded.IsEditable) {
        if (window.location.href.indexOf('/RebateRequest/ConfirmReceivingRequest') > -1 || window.location.href.indexOf('/RebateRequest/MeasurementCommitteeDecision') > -1 || this.currentUser.IsAdmin) {

          this.formMode = FormMode.Details;

          this.rebateRequestForm.disable();

        } else {
          //Edit Mode
          this.formMode = FormMode.Edit;
          this.showOptionDev = true;
        }
      } else {
        //Clone Request
        if (this.rebateRequestLoaded.CanClone && this.isCloneComponent) {
          //Edit Mode
          //this.getRequestTimeBeforeSailingDate();
          this.formMode = FormMode.Edit;
          this.showOptionDev = true;
        }

        else {

          this.formMode = FormMode.Details;

          this.rebateRequestForm.disable();

        }
      }
      if (this.rebateRequestLoaded.RequireModificationRecentComment != null) {
        this.isRequireModificationNotesExist = true;
        this.requireModificationNotes = this.rebateRequestLoaded.RequireModificationRecentComment.Comment;
      }
      const el = document.getElementsByClassName('sectionTitle');
      /*el[0].scrollIntoView({ behavior: 'smooth' });*/
    } else {
      //Enable Error
      this.submitConfirmationMode = ConfirmationMode.Error;
      this.isFormValid = true;
    }
    //Disable Loader
    this.globalServices.isLoaderEnabled = false;
  }
  fillRebateRequestObject(): void {
    this.currentUserEmail = this.rebateRequestLoaded.RequestorEmail;
    //Tab One
    let isShipLoaded: string = this.rebateRequestLoaded.IsShipLoaded ? "true" : "false";
    let isScrubberFitted: string = this.rebateRequestLoaded.IsScrubberFitted ? "true" : "false";
    let mainEngineFuelId;
    if (this.rebateRequestLoaded.MainEngineFuelId == null && (this.rebateRequestLoaded.OtherMainEngineFuel == null || this.rebateRequestLoaded.OtherMainEngineFuel == ""))
      mainEngineFuelId = '';
    else if (this.rebateRequestLoaded.MainEngineFuelId == null && this.rebateRequestLoaded.OtherMainEngineFuel != null)
      mainEngineFuelId = -1;
    else
      mainEngineFuelId = this.rebateRequestLoaded.MainEngineFuelId;
    this.rebateRequestForm.controls['TabOne'].patchValue({
      OperatorName: this.rebateRequestLoaded.OperatorName,
      OperatorEmail: this.rebateRequestLoaded.OperatorEmail,
      VesselName: this.rebateRequestLoaded.VesselName,
      VesselTypeId: this.rebateRequestLoaded.VesselTypeId,
      ExNames: this.rebateRequestLoaded.ExNames,
      YearBuilt: this.rebateRequestLoaded.YearBuilt === null ? '' : new Date(this.rebateRequestLoaded.YearBuilt),
      CallSign: this.rebateRequestLoaded.CallSign,
      IMONo: this.rebateRequestLoaded.IMONo,
      DWT: this.rebateRequestLoaded.DWT,
      SCNT: this.rebateRequestLoaded.SCNT,
      LastTransitDate: this.rebateRequestLoaded.LastTransitDate != null && this.rebateRequestLoaded.LastTransitDate != "" ? new Date(this.rebateRequestLoaded.LastTransitDate) : null,
      LPGLNGCapacity: this.rebateRequestLoaded.LPGLNGCapacity,
      ReeferCapacity: this.rebateRequestLoaded.ReeferCapacity,
      MAXDraught: this.rebateRequestLoaded.MAXDraught,
      TRNDraught: this.rebateRequestLoaded.TRNDraught,
      Beam: this.rebateRequestLoaded.Beam,
      DesignSpeed: this.rebateRequestLoaded.DesignSpeed,
      FuelIFO: this.rebateRequestLoaded.FuelIFO,
      IsScrubberFitted: isScrubberFitted,
      MainEngineFuelId: mainEngineFuelId,
      OtherMainEngineFuel: this.rebateRequestLoaded.OtherMainEngineFuel,
      FuelDO: this.rebateRequestLoaded.FuelDO,
      CargoKind: this.rebateRequestLoaded.CargoKind,
      CargoQuantity: this.rebateRequestLoaded.CargoQuantity,
      IsShipLoaded: isShipLoaded,
      AdminDirectionId: this.rebateRequestLoaded.LongHaulRequestOptions[0].DirectionId,
      AdminDateOfSailing: new Date(this.rebateRequestLoaded.LongHaulRequestOptions[0].DateOfSailing),
      AdminETA: new Date(this.rebateRequestLoaded.LongHaulRequestOptions[0].ETA),
      RebateNote: this.rebateRequestLoaded.RebateNote
    });

    if (!this.isCloneComponent) {
      const optionsArray = <FormArray>this.rebateRequestForm.controls['TabTwo'].get('Options');
      this.rebateRequestOptionsArrLength = this.rebateRequestLoaded.LongHaulRequestOptions.length + 1;
      for (let i: number = 0; i < this.rebateRequestLoaded.LongHaulRequestOptions.length; i++) {
        if (i > 0)
          (<FormArray>this.rebateRequestForm.controls['TabTwo'].get('Options')).push(this.buildLongHaulOptionsForm());
        optionsArray.controls[i].patchValue({
          ActualSpeed: this.rebateRequestLoaded.LongHaulRequestOptions[i].ActualSpeed,
          LastCountryOriginId: this.rebateRequestLoaded.LongHaulRequestOptions[i].LastCountryOriginId,
          LastPortOriginId: this.rebateRequestLoaded.LongHaulRequestOptions[i].LastPortOriginId == null ? -1 : this.rebateRequestLoaded.LongHaulRequestOptions[i].LastPortOriginId,
          OtherLastPortOrigin: this.rebateRequestLoaded.LongHaulRequestOptions[i].OtherLastPortOrigin,
          FirstCountryDestinationId: this.rebateRequestLoaded.LongHaulRequestOptions[i].FirstCountryDestinationId,
          FirstPortDestinationId: this.rebateRequestLoaded.LongHaulRequestOptions[i].FirstPortDestinationId == null ? -1 : this.rebateRequestLoaded.LongHaulRequestOptions[i].FirstPortDestinationId,
          OtherFirstPortDestination: this.rebateRequestLoaded.LongHaulRequestOptions[i].OtherFirstPortDestination,
          DistanceMilesSuez: this.rebateRequestLoaded.LongHaulRequestOptions[i].DistanceMilesSuez,
          DistanceMilesPanama: this.rebateRequestLoaded.LongHaulRequestOptions[i].DistanceMilesPanama,
          DiffInDistance: this.rebateRequestLoaded.LongHaulRequestOptions[i].DiffInDistance,
          WhetherSuez: this.rebateRequestLoaded.LongHaulRequestOptions[i].WhetherSuez,
          WhetherPanama: this.rebateRequestLoaded.LongHaulRequestOptions[i].WhetherPanama,
          DurationSuez: this.rebateRequestLoaded.LongHaulRequestOptions[i].DurationSuez,
          DurationPanama: this.rebateRequestLoaded.LongHaulRequestOptions[i].DurationPanama,
          AntiPiracyCostSuez: this.rebateRequestLoaded.LongHaulRequestOptions[i].AntiPiracyCostSuez,
          AntiPiracyCostPanama: this.rebateRequestLoaded.LongHaulRequestOptions[i].AntiPiracyCostPanama,
          IFOTon: this.rebateRequestLoaded.LongHaulRequestOptions[i].IFOTon,
          IFOTonPrice: this.rebateRequestLoaded.LongHaulRequestOptions[i].IFOTonPrice,
          DOTon: this.rebateRequestLoaded.LongHaulRequestOptions[i].DOTon,
          DOTonPrice: this.rebateRequestLoaded.LongHaulRequestOptions[i].DOTonPrice,
          DailyTimeCharter: this.rebateRequestLoaded.LongHaulRequestOptions[i].DailyTimeCharter,
          SCTolls: this.rebateRequestLoaded.LongHaulRequestOptions[i].SCTolls,
          SCOtherCharges: this.rebateRequestLoaded.LongHaulRequestOptions[i].SCOtherCharges,
          PanamaTolls: this.rebateRequestLoaded.LongHaulRequestOptions[i].PanamaTolls,
          PanamaOtherCharges: this.rebateRequestLoaded.LongHaulRequestOptions[i].PanamaOtherCharges,
          CargoSuezTon: this.rebateRequestLoaded.LongHaulRequestOptions[i].CargoSuezTon,
          CargoPanamaTon: this.rebateRequestLoaded.LongHaulRequestOptions[i].CargoPanamaTon,
          FreightPerTon: this.rebateRequestLoaded.LongHaulRequestOptions[i].FreightPerTon,
          CargoLostValue: this.rebateRequestLoaded.LongHaulRequestOptions[i].CargoLostValue,
          TotalCostSuez: this.rebateRequestLoaded.LongHaulRequestOptions[i].TotalCostSuez,
          TotalCostPanama: this.rebateRequestLoaded.LongHaulRequestOptions[i].TotalCostPanama,
          DiffInCost: this.rebateRequestLoaded.LongHaulRequestOptions[i].DiffInCost,
          SuggestedRebate: this.rebateRequestLoaded.LongHaulRequestOptions[i].SuggestedRebate,
          DateOfSailing: new Date(this.rebateRequestLoaded.LongHaulRequestOptions[i].DateOfSailing),
          ETA: new Date(this.rebateRequestLoaded.LongHaulRequestOptions[i].ETA),
          Id: this.rebateRequestLoaded.LongHaulRequestOptions[i].Id,
          IsOptionDeleted: false
        });
        this.mapCountriesPortsKeys(i, this.rebateRequestLoaded.LongHaulRequestOptions[i].LastCountryOriginId, this.rebateRequestLoaded.LongHaulRequestOptions[i].FirstCountryDestinationId, this.rebateRequestLoaded.LongHaulRequestOptions[i].LastPortOriginId, this.rebateRequestLoaded.LongHaulRequestOptions[i].FirstPortDestinationId, this.rebateRequestLoaded.LongHaulRequestOptions[i].OtherLastPortOrigin, this.rebateRequestLoaded.LongHaulRequestOptions[i].OtherFirstPortDestination);
      }
      (<FormArray>this.rebateRequestForm.controls['TabTwo'].get('Options')).push(this.buildLongHaulOptionsForm());
    } else {
      // this.date22 = new Date(this.rebateRequestLoaded.LongHaulRequestOptions[0].DateOfSailing);
      //this.date11 = this.datepipe.transform(this.date22 ,'dd-MM-yyyy');
      // const optionsArray = <FormArray>this.rebateRequestForm.controls['TabTwo'].get('Options');
      //optionsArray.controls[optionsArray.length - 1].get('DateOfSailing').setValue(this.rebateRequestLoaded.LongHaulRequestOptions[0].DateOfSailing);

      /*optionsArray.controls[0].patchValue({
        DateOfSailing: this.date11
      })*/

      this.rebateRequestForm.controls['TabTwo'].get('DirectionId').disable();
    }
    //Tab Two
    this.clonedComponentDirectionId = this.rebateRequestLoaded.LongHaulRequestOptions[0].DirectionId;
    this.rebateRequestForm.controls['TabTwo'].patchValue({
      DirectionId: this.rebateRequestLoaded.LongHaulRequestOptions[0].DirectionId,
      Name: this.rebateRequestLoaded.Name,
      EMail: this.rebateRequestLoaded.EMail,
      Fax: this.rebateRequestLoaded.Fax
    });

    this.globalServices.isLoaderEnabled = false;
  }
  mapCountriesPortsKeys(index, lastCountryOriginId, firstCountryDestinationId, lastPortOriginId, firstPortDestinationId, otherLastPortOrigin, otherFirstPortDestination): void {

    let lastCountryOrigin: OptionKey = new OptionKey();
    lastCountryOrigin.Index = index;
    lastCountryOrigin.Value = lastCountryOriginId;
    lastCountryOrigin.Text = this.countries.filter(c => c.Id == lastCountryOrigin.Value)[0].NameEN;
    this.lastCountryOriginsArr.push(lastCountryOrigin);
    //First Country Destination Key
    let firstCountryDestination: OptionKey = new OptionKey();
    firstCountryDestination.Index = index;
    firstCountryDestination.Value = firstCountryDestinationId;
    firstCountryDestination.Text = this.countries.filter(c => c.Id == firstCountryDestination.Value)[0].NameEN;
    this.firstCountryDestinationsArr.push(firstCountryDestination);
    //Last Port Origin Key
    let lastPortOrigin: OptionKey = new OptionKey();
    lastPortOrigin.Index = index;
    lastPortOrigin.Value = lastPortOriginId;
    lastPortOrigin.Text = +lastPortOriginId != -1 && lastPortOriginId != null ? this.ports.filter(c => c.Id == lastPortOriginId)[0].NameEN : otherLastPortOrigin;
    this.lastPortOriginsArr.push(lastPortOrigin);
    //First Port Destination Key
    let firstPortDestination: OptionKey = new OptionKey();
    firstPortDestination.Index = index;
    firstPortDestination.Value = firstPortDestinationId;
    firstPortDestination.Text = +firstPortDestinationId != -1 && firstPortDestinationId != null ? this.ports.filter(c => c.Id == firstPortDestinationId)[0].NameEN : otherFirstPortDestination;
    this.firstPortDestinationsArr.push(firstPortDestination);
  }
  editMapCountriesKeys(index, lastCountryOriginId, firstCountryDestinationId, lastPortOriginId, firstPortDestinationId, otherLastPortOrigin, otherFirstPortDestination): void {
    //Last Country Origins Key
    let lastCountryOrigin: OptionKey = this.lastCountryOriginsArr[index];
    lastCountryOrigin.Value = lastCountryOriginId;
    lastCountryOrigin.Text = this.countries.filter(c => c.Id == lastCountryOrigin.Value)[0].NameEN;
    //First Country Destination Key
    let firstCountryDestination: OptionKey = this.firstCountryDestinationsArr[index];
    firstCountryDestination.Value = firstCountryDestinationId;
    firstCountryDestination.Text = this.countries.filter(c => c.Id == firstCountryDestination.Value)[0].NameEN;
    //Last Port Origin Key
    let lastPortOrigin: OptionKey = this.lastPortOriginsArr[index];
    lastPortOrigin.Index = index;
    lastPortOrigin.Value = lastPortOriginId;
    lastPortOrigin.Text = +lastPortOriginId != -1 && lastPortOriginId != null ? this.ports.filter(c => c.Id == lastPortOriginId)[0].NameEN : otherLastPortOrigin;
    this.lastPortOriginsArr.push(lastPortOrigin);
    //First Port Destination Key
    let firstPortDestination: OptionKey = this.firstPortDestinationsArr[index];
    firstPortDestination.Index = index;
    firstPortDestination.Value = firstPortDestinationId;
    firstPortDestination.Text = +firstPortDestinationId != -1 && firstPortDestinationId != null ? this.ports.filter(c => c.Id == firstPortDestinationId)[0].NameEN : otherFirstPortDestination;
    this.firstPortDestinationsArr.push(firstPortDestination);
  }
  navigateToParentRequestDetails(): void {
    localStorage.setItem('lsRebateRequestId', this.rebateRequestLoaded.BaseRequest.ParentRequestId);
    window.open('#/RebateRequest/BaseRequestDetails', '_blank');
  }
  onVesselConditionChange(value: string): void {
    if (value == "true") {
      this.showCargoWarning = false;
      (this.rebateRequestForm.controls['TabOne'] as FormGroup).controls['CargoKind'].setValidators([Validators.required, Validators.pattern("[^=]+"), Validators.maxLength(200)]);
      (this.rebateRequestForm.controls['TabOne'] as FormGroup).controls['CargoKind'].updateValueAndValidity();
      (this.rebateRequestForm.controls['TabOne'] as FormGroup).controls['CargoQuantity'].setValidators([Validators.required, Validators.pattern("^[0-9]{1,6}$"), Validators.maxLength(200)]);
      (this.rebateRequestForm.controls['TabOne'] as FormGroup).controls['CargoQuantity'].updateValueAndValidity();
    } else {
      this.showCargoWarning = false;
      (this.rebateRequestForm.controls['TabOne'] as FormGroup).controls['CargoKind'].reset();
      (this.rebateRequestForm.controls['TabOne'] as FormGroup).controls['CargoKind'].clearValidators();
      (this.rebateRequestForm.controls['TabOne'] as FormGroup).controls['CargoKind'].updateValueAndValidity();
      (this.rebateRequestForm.controls['TabOne'] as FormGroup).controls['CargoQuantity'].reset();
      (this.rebateRequestForm.controls['TabOne'] as FormGroup).controls['CargoQuantity'].clearValidators();
      (this.rebateRequestForm.controls['TabOne'] as FormGroup).controls['CargoQuantity'].updateValueAndValidity();
    }
  }
  onMainEngineFuelTypeChange(mainEngineFuelTypeId: number): void {
    if (mainEngineFuelTypeId == -1) {
      (this.rebateRequestForm.controls['TabOne'] as FormGroup).controls['OtherMainEngineFuel'].setValidators([Validators.required]);
      (this.rebateRequestForm.controls['TabOne'] as FormGroup).controls['OtherMainEngineFuel'].updateValueAndValidity();
    } else {
      (this.rebateRequestForm.controls['TabOne'] as FormGroup).controls['OtherMainEngineFuel'].reset();
      (this.rebateRequestForm.controls['TabOne'] as FormGroup).controls['OtherMainEngineFuel'].clearValidators();
      (this.rebateRequestForm.controls['TabOne'] as FormGroup).controls['OtherMainEngineFuel'].updateValueAndValidity();
    }
  }
  goToTermsAndConditions(): void {
    window.open(AppConfig.settings.apiServer.LongHaulTermsEN, '_blank');
  }
  reloadComponent(): void {
    window.location.reload();
  }
  setDateTimeDefault() {
    var defaultTimeForDates = ",12:00:00 PM";
    this.rebateRequestObject.LastTransitDate = this.rebateRequestObject.LastTransitDate != null && this.rebateRequestObject.LastTransitDate != "" ? new Date(this.rebateRequestObject.LastTransitDate.toLocaleDateString() + defaultTimeForDates) : null;
    this.rebateRequestObject.Options.forEach(function (option) {
      option.DateOfSailing = new Date(option.DateOfSailing.toLocaleDateString() + defaultTimeForDates);
      option.ETA = new Date(option.ETA.toLocaleDateString() + defaultTimeForDates);
    });
  }

  //#endregion
}

enum FormMode {
  New = 1,
  Edit = 2,
  Details = 3
}

enum ConfirmationMode {
  Success = 1,
  Error = 2
}
